export default function (priceObj) {
  return `${priceObj.currency.prefix}${priceObj.short}${priceObj.currency.suffix}`;
}
